<template lang="pug">
a(class="linkServices" @click="logout" v-if="isAuthenticated")
	.frame
	span.text Logout
router-link(:to="{name: 'connect'}", v-else-if="!isAuthenticated"): span Login
</template>

<script>
import Vue from 'vue'

export default {
	name: 'login-button',
	methods: {
		logout: function () {
			Vue.e24.security.logout().then((resp) => {
				this.$router.push({name: 'connect', params: {goodbye: 'TRUE'}})
			})
		}
	},
	computed: {
		isAuthenticated: function () {
			return Vue.e24.security.isAuthenticated()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/login-button.vue